// Azure Blob Storage configuration - Single source of truth
const GROCERIES_DATA_URL = 'https://beanteastorageaccount.blob.core.windows.net/flyers/dev-db-groceries.json?sp=r&st=2026-02-06T09:03:00Z&se=2028-03-01T17:18:00Z&sv=2024-11-04&sr=b&sig=BJEMcSV1PQbLCOcS0EF5hpw%2BIiXCboC5MZRP%2Bl0uN6Q%3D';

export { GROCERIES_DATA_URL };

